<template>
  <div class="template_pop">
    <div>
      <img src="@/assets/images/account/picture0.png" />
      <div>请您授权企优托服务</div>
      <div>
        访问您的基本信息（如昵称、头像、地区、性别等），以便为您提供更加个性化的服务。
      </div>
      <el-button type="primary" @click="empower">微信一键授权</el-button>
      <i
        class="el-icon-close"
        @click="$store.commit('empowerParams', { empowerShow: false })"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {}
  },
  methods: {
    empower() {
      let url = this.$removeQueryParameter(location.href, 'code')
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx86aef3445f200f66&redirect_uri=${encodeURIComponent(
        url
      )}+%0A&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
    },
  },
  computed: {
    ...mapState(['empowerParams']),
  },
}
</script>
<style lang="scss" scoped>
.template_pop {
  > div {
    color: var(--color_mainText);
    font-weight: 600;
    font-size: 16px;
    text-align: center;
    > div:nth-child(2) {
      margin-bottom: 10px;
      font-size: 20px;
    }
    > div:nth-child(3) {
      margin-bottom: 10px;
      font-size: 12px;
      text-align: left;
    }
    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin: 20px auto;
    }
  }
}
</style>
